document.addEventListener('DOMContentLoaded', function() {
  // Use the CollectionContextManager to update breadcrumb
  if (window.collectionContextManager) {
    window.collectionContextManager.updateBreadcrumb();
  }
}); 